import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { select_user } from '../store/auth_slice';

export const Unauthorized = () => {
  const navigate = useNavigate();
  const user = useSelector(select_user);

  return (
    <div className="min-h-screen bg-gradient-to-br from-forest-green to-dark-forest flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-xl p-8 text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-6">
            <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Access Denied</h1>
          
          {/* Message */}
          <p className="text-gray-600 mb-6">
            You don't have permission to access this page.
          </p>

          {/* User Info */}
          {user && (
            <div className="bg-gray-50 rounded-md p-4 mb-6 text-sm">
              <p className="text-gray-700">
                <span className="font-medium">Current Role:</span>{' '}
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-forest-green bg-opacity-10 text-forest-green capitalize">
                  {user.role}
                </span>
              </p>
              <p className="text-gray-500 mt-2">
                Contact your administrator if you believe you should have access to this page.
              </p>
            </div>
          )}

          {/* Actions */}
          <div className="space-y-3">
            <button
              onClick={() => navigate(-1)}
              className="w-full bg-forest-green text-white py-3 rounded-md hover:bg-dark-forest transition duration-200 font-medium"
            >
              Go Back
            </button>
            
            <Link
              to="/dashboard"
              className="block w-full bg-gray-100 text-gray-700 py-3 rounded-md hover:bg-gray-200 transition duration-200 font-medium"
            >
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};